import { autoinject, singleton } from "aurelia-framework";
import { RouteConfig, RouterEvent } from "aurelia-router";
import { EventAggregator } from "aurelia-event-aggregator";
import { RoutesService } from "../../routes/routes";
import * as Enumerable from "linq";

@singleton()
@autoinject()
export class ActiveMenuItemsService {
	public active: RouteConfig | RouteConfig[] = null;

	public constructor(eventAggregator: EventAggregator, private routerService: RoutesService) {
		eventAggregator.subscribe(RouterEvent.Processing, this.onNavigationComplete);
	}

	public isActive(config: RouteConfig): boolean {
		return config && this.active
			? Array.isArray(this.active) 
				? this.active.some(c => c.name === config.name)
				: config.name === this.active.name
			: false;
	}

	public async setActiveFromMenuItem(menuItemKey: string): Promise<void> {
		const menuItems = await this.routerService.getAppMenu();

		const find = (): boolean => {
			const menuItem = Enumerable.from(menuItems).selectMany(x=> x.menuTabs).firstOrDefault(mi => mi.key === menuItemKey);

			if (!menuItem) {
				return false;
			}

			this.active = menuItem.routes;
			return true;
		}

		if (menuItems) {
			const isFound = find();

			if (isFound) {
				return;
			}
		}

		find();
	}

	private onNavigationComplete = () => {
		this.active = null;
	}
}
